module.exports = __webpack_public_path__ + "media/images/emblems/Les_Clees-coat_of_arms-338f3bbe08748b5542633e0f94a8ab3c.svg";